/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PatchedNotification
 */
export interface PatchedNotification {
    /**
     * 
     * @type {number}
     * @memberof PatchedNotification
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedNotification
     */
    eventType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedNotification
     */
    severity?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedNotification
     */
    read?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof PatchedNotification
     */
    timestamp?: Date;
    /**
     * 
     * @type {string}
     * @memberof PatchedNotification
     */
    readonly objectType?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedNotification
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedNotification
     */
    message?: string;
    /**
     * Whether this notification has been enhanced by AI
     * @type {boolean}
     * @memberof PatchedNotification
     */
    aiEnhanced?: boolean;
    /**
     * Whether this notification has been sent via email
     * @type {boolean}
     * @memberof PatchedNotification
     */
    emailAlerted?: boolean;
    /**
     * Whether this notification has been sent to Slack
     * @type {boolean}
     * @memberof PatchedNotification
     */
    slackAlerted?: boolean;
    /**
     * Whether this notification has been displayed on the dashboard
     * @type {boolean}
     * @memberof PatchedNotification
     */
    dashboardAlerted?: boolean;
}

/**
 * Check if a given object implements the PatchedNotification interface.
 */
export function instanceOfPatchedNotification(value: object): value is PatchedNotification {
    return true;
}

export function PatchedNotificationFromJSON(json: any): PatchedNotification {
    return PatchedNotificationFromJSONTyped(json, false);
}

export function PatchedNotificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedNotification {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'eventType': json['event_type'] == null ? undefined : json['event_type'],
        'severity': json['severity'] == null ? undefined : json['severity'],
        'read': json['read'] == null ? undefined : json['read'],
        'timestamp': json['timestamp'] == null ? undefined : (new Date(json['timestamp'])),
        'objectType': json['object_type'] == null ? undefined : json['object_type'],
        'title': json['title'] == null ? undefined : json['title'],
        'message': json['message'] == null ? undefined : json['message'],
        'aiEnhanced': json['ai_enhanced'] == null ? undefined : json['ai_enhanced'],
        'emailAlerted': json['email_alerted'] == null ? undefined : json['email_alerted'],
        'slackAlerted': json['slack_alerted'] == null ? undefined : json['slack_alerted'],
        'dashboardAlerted': json['dashboard_alerted'] == null ? undefined : json['dashboard_alerted'],
    };
}

  export function PatchedNotificationToJSON(json: any): PatchedNotification {
      return PatchedNotificationToJSONTyped(json, false);
  }

  export function PatchedNotificationToJSONTyped(value?: Omit<PatchedNotification, 'id'|'object_type'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'event_type': value['eventType'],
        'severity': value['severity'],
        'read': value['read'],
        'timestamp': value['timestamp'] == null ? undefined : ((value['timestamp']).toISOString()),
        'title': value['title'],
        'message': value['message'],
        'ai_enhanced': value['aiEnhanced'],
        'email_alerted': value['emailAlerted'],
        'slack_alerted': value['slackAlerted'],
        'dashboard_alerted': value['dashboardAlerted'],
    };
}

